import { render } from "./AnswerTheQuestion.vue?vue&type=template&id=4235dae0&scoped=true"
import script from "./AnswerTheQuestion.vue?vue&type=script&lang=js"
export * from "./AnswerTheQuestion.vue?vue&type=script&lang=js"

import "./AnswerTheQuestion.vue?vue&type=style&index=0&id=4235dae0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4235dae0"]])

export default __exports__